export { ClassicCVAbout } from './ClassicCVAbout';
